<ng-container *transloco="let t">
<ng-template #gatherLeadSource>

  <form class="form w-100" #leadSourceForm="ngForm" novalidate id="leadSourceForm" name="leadSourceForm">
    @if (inEditMode) {
      <div class="fv-row row">
        <div class="col-sm-4 col-form-label fw-bold fs-6 editor-label">Pick Agent Referral from a List</div>
        <div class="col-sm-2 form-check form-switch form-check-custom form-check-solid">
          <input class="form-check-input h-20px w-30px" type="checkbox" name="pickReferralFromAList"
            id="pickReferralFromAList" [(ngModel)]="step.pickAgentReferralFromAList" />
          <label class="form-check-label" for="pickReferralFromAList">
            {{step.pickAgentReferralFromAList ? t('common.yes') : t('common.no')}}
          </label>
        </div>
      </div>

      @if (availableLeadSourceOptions.length) {
        <div class="fv-row">
          <div class="col-sm-3 col-form-label fw-bold fs-6 editor-label">Pick Options</div>
          @for (availableOption of availableLeadSourceOptions; track availableOption.name) {
            <div class="checkbox mb-3">
              <label class="form-check form-check-inline form-check-solid me-2"
                for="availableOption_{{availableOption.name}}">
                <input id="availableOption_{{availableOption.name}}" name="availableOption_{{availableOption.name}}"
                  type="checkbox" (change)="optionsSelectedToPresentToUserChanged(availableOption, $event)"
                  [checked]="valuesOfOptionsSelectedToBePresentedToUserAsChoices.includes(availableOption.name.toLowerCase())"
                  class="form-check-input">
                <span class="fw-bold ps-2 fs-5">{{availableOption.text}}</span>
              </label>
            </div>
          }
        </div>
      }
    }

    <div class="row mb-4">
      <div class="col-md-12 fv-row">
        <label class="form-label mb-2 required">{{ t('wizard.leadSource.howDidYouHear') }}</label>
        <select #leadCameFrom="ngModel" class="form-select form-select-solid"
          [ngClass]="{'is-invalid' : leadCameFrom && leadCameFrom.touched && leadCameFrom.invalid}"
          required
          [(ngModel)]="leadSourceType"
          (change)="onLeadSourceChangedType()"
          name="howDidYouHearAboutUs">
          <option [ngValue]="null">{{ t('common.selectOne') }}</option>
          @for (leadSourceOption of step.leadSourceOptions; track leadSourceOption.value) {
            <option value="{{leadSourceOption.value}}">{{ leadSourceOptionLabel(leadSourceOption) }}</option>
          }
        </select>
        <div class="invalid-feedback">{{ t('wizard.leadSource.pleaseSelectHowYouHeard') }}</div>
      </div>
    </div>
    @if ((leadSourceType === 'Agents' || leadSourceType === 'Real Estate Agent') && step.pickAgentReferralFromAList && !useManualAgentEntry) {
      <div class="row mb-4">
        <div class="col-md-12 fv-row">
          <label class="form-label mb-2">{{ t('wizard.leadSource.whoWasTheAgent') }}</label>
          <p-select
            [(ngModel)]="leadSourceAgent"
            (ngModelChange)="onAgentChanged()"
            [options]="referralAgentGroups"
            optionLabel="name"
            optionValue="id"
            optionGroupLabel="label"
            optionGroupChildren="items"
            [group]="true"
            styleClass="form-select-solid"
            id="lead-source-agent"
            name="leadSourceAgent"
            [placeholder]="t('wizard.leadSource.selectAnAgent')"
            [filter]="true"
            [showClear]="true"
            appendTo="body"
          >
            <ng-template let-group pTemplate="group">
              {{ group.label }}
            </ng-template>

            <ng-template let-item pTemplate="item">
              {{ item.name }}
            </ng-template>
          </p-select>
          <div class="invalid-feedback">{{ t('wizard.leadSource.pleaseSelectAgent') }}</div>
        </div>
      </div>
    }
    @if (shouldShowAgentTypeSelector()) {
      <div class="row mb-4">
        <div class="col-md-12 fv-row">
          <label class="form-label mb-2 required">{{ t('wizard.leadSource.whatTypeOfAgent') }}</label>
          <p-select
            [(ngModel)]="agentTypeId"
            (ngModelChange)="onAgentTypeChanged()"
            [options]="agentTypes"
            optionLabel="agentTypeName"
            optionValue="agentTypeId"
            styleClass="form-select-solid"
            id="lead-source-agent-type"
            name="leadSourceAgentType"
            required
            [placeholder]="t('wizard.leadSource.selectAnAgentType')"
            [filter]="true"
            appendTo="body"
          >
          </p-select>
          <div class="invalid-feedback">{{ t('wizard.leadSource.pleaseSelectAgentType') }}</div>
        </div>
      </div>
    }
    @if (shouldShowReferralTextInput()) {
      <div class="row mb-4">
        <div class="col-md-12 fv-row">
          <label class="form-label mb-2 required">{{referralSourceLabel}}</label>
          <!-- A browser input cap, not a keydown guard: it covers pastes and drops too, and
               does not have to swallow Tab and the arrow keys to do it.
               [attr.maxlength] and NOT [maxlength] - the latter matches Angular's
               MaxLengthValidator ([maxlength][ngModel]), which would mark a stored value
               longer than the cap invalid. validate() blocks Next on form validity, so that
               would strand a borrower on this step over data they did not type. -->
          <input class="form-control form-control-lg form-control-solid" type="text" name="leadSource" required
            [ngClass]="{'is-invalid' : leadSourceValue && leadSourceValue.touched && leadSourceValue.invalid}" autocomplete="off"
            [(ngModel)]="leadSource" #leadSourceValue="ngModel"
            [attr.maxlength]="maxReferralSourceLength"/>
          <div class="invalid-feedback">{{ t('wizard.leadSource.pleaseSelectHowYouHeard') }}</div>
          <span class="text-muted" style="font-style: italic;"> {{ t('wizard.leadSource.charactersLeft', { count: noOfCharactersLeft }) }}</span>
        </div>
      </div>
    }
  </form>
</ng-template>

<wizard-step-template [stepMainTemplate]="gatherLeadSource" [step]="step" [stepComponent]="this"></wizard-step-template>
</ng-container>
